var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDashboardbtnMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#BCADF9",
    transform: "rotate(-180 32 32)",
    y: 25.6,
    width: 64,
    height: 12.8,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 58V6a6 6 0 0 1 6-6h.8a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-.8a6 6 0 0 1-6-6z",
    fill: "#6A48F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDashboardbtnMore);
export default __webpack_public_path__ + "static/media/icons_dashboardbtn_more.56e3aa90d2a420a81602acc9473e059d.svg";
export { ForwardRef as ReactComponent };